<template>
  <div>
    <Dialog
      :show-header="false"
      :visible="active"
      :style="{ maxWidth: '90%', width: '600px' }"
      :modal="true"
      :closable="false"
    >
      <div style="min-height: 400px" class="p-mt-4">
        <!-- <div v-if="!isProduction">
          {{ input }}
        </div> -->
        <div class="title is-3">{{ title }}</div>
        <!-- Actions (NO ID): Create Actions (ID): Edit, Delete, Reschedule Time Date
      Venue Surface Team 1 Team 2 Delete Reschedule -->
        <div class="p-grid p-mt-1">
          <div v-if="input && schedule && schedule.unscheduled > 0 && !input.timeslot.id" class="p-col-12">
            <div class="title is-4">{{ $t("assign-unscheduled-game") }}</div>
            <div class="p-grid">
              <div class="p-col-4 bold">{{ $t("home") }}</div>
              <div class="p-col-4 bold">{{ $t("GameTable.column.visitor") }}</div>
              <div class="p-col-4"></div>
            </div>
            <div v-for="t in schedule.unscheduled_items" :key="t.id" class="p-grid p-mb-2">
              <div class="p-col-4">
                {{ t.game.home.name }}
              </div>
              <div class="p-col-4">
                {{ t.game.visitor.name }}
              </div>
              <div class="p-col-4">
                <Button :label="$t('choose')" @click="assign(t)" />
              </div>
            </div>
            <div class="title is-5 mt-3">{{ $t("or-create-a-new-one") }}</div>
          </div>
          <div class="p-col-6" v-if="!iscalendar">
            <div class="title is-6">{{ $t("start-date-time") }}</div>
            <datetime
              :use12-hour="true"
              class="w100"
              type="datetime"
              @input="setEnd"
              v-model="timeslot.start"
            ></datetime>
          </div>
          <div class="p-col-6" v-if="!iscalendar">
            <div class="title is-6">{{ $t("end-date-time") }}</div>
            <datetime
              class="w100"
              :use12-hour="true"
              v-if="timeslot.start"
              type="datetime"
              @input="checkEnd"
              v-model="timeslot.finish"
            ></datetime>
            <p v-else>{{ $t("enter-start-first") }}</p>
          </div>
        </div>

        <div class="p-grid p-mt-2">
          <div class="p-col-6">
            <div class="title is-6">{{ $t("GameTable.column.venue") }}</div>
            <Dropdown
              class="w100"
              :options="seasonItems.venues"
              optionLabel="name"
              optionValue="id"
              :placeholder="$t('select-venue')"
              v-model="timeslot.venue_id"
            />
          </div>
          <div class="p-col-6">
            <div class="title is-6">{{ $t("GameTable.column.surface") }}</div>
            <Dropdown
              class="w100"
              v-if="timeslot.venue_id"
              :options="seasonItems.surfaces"
              optionLabel="name"
              optionValue="id"
              :placeholder="$t('select-surface')"
              v-model="timeslot.surface_id"
            />
            <p v-else>{{ $t("select-venue-first") }}</p>
          </div>
        </div>

        <div class="p-grid p-mt-2">
          <div class="p-col-6">
            <div class="title is-6">
              {{ $t("visitor-team") }} <a v-if="isGame" style="" @click="swapTeams"> {{ $t("swap") }} </a>&nbsp;
            </div>
            <Dropdown
              v-if="
                !game.visitor_id || !eligibleIDs.length || (eligibleIDs && eligibleIDs.indexOf(game.visitor_id) > -1)
              "
              class="w100"
              :options="eligibleTeams"
              optionLabel="name"
              optionValue="id"
              :placeholder="$t('select-team')"
              v-model="game.visitor_id"
            />
            <div v-else>
              {{ getSeasonTeam(game.visitor_id).name }}
              <br />
              {{ $t("filter-preventing-change") }}
            </div>
          </div>
          <div class="p-col-6">
            <div class="title is-6">{{ $t("home-team") }}</div>
            <Dropdown
              v-if="!game.home_id || !eligibleIDs.length || (eligibleIDs && eligibleIDs.indexOf(game.home_id) > -1)"
              class="w100"
              :options="eligibleTeams"
              optionLabel="name"
              optionValue="id"
              :placeholder="$t('select-team')"
              v-model="game.home_id"
            />
            <div v-else>
              {{ getSeasonTeam(game.home_id).name }}
              <br />
              {{ $t("filter-preventing-change") }}
            </div>
          </div>
        </div>

        <!-- {{ seasonItems.schedules }} -->
        <div class="p-grid p-mt-2" v-if="(iscalendar || master) && !isGame">
          <div class="p-col-12">
            <div class="title is-6">{{ $t("AppMenu.schedule") }}</div>
            <Dropdown
              class="w100"
              :options="seasonItems.schedules"
              optionLabel="name"
              optionValue="id"
              :placeholder="$t('select-schedule')"
              v-model="game.schedule_id"
            />
          </div>
        </div>

        <div class="p-mt-5">
          <Button @click="save" :disabled="!valid"> {{ $t("Button.save") }} </Button>
          <br /><br />
          <Button class="p-button-text" @click="emitHide"> {{ $t("Button.cancel") }} </Button>
          <br />
          <div style="float: right">
            <a v-if="isGame" style="" @click="startSplit"> {{ $t("split") }} </a>&nbsp;
            <a v-if="isGame && !iscalendar" style="" @click="startRemove(false)"> {{ $t("Button.unschedule") }} </a
            >&nbsp;
            <a v-if="input && !iscalendar" style="color: red" @click="startRemove(true)">
              {{ $t("Button.delete") }}
            </a>
          </div>
          <br /><br /><br /><br />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: ["master", "input", "active", "schedule", "start", "iscalendar", "teams"],
  // dddd
  data() {
    return {
      updateItem: null,
      date: null,
      timeslot: {
        start: null,
        finish: null,
        venue_id: null,
        surface_id: null,
      },
      game: {
        home_id: null,
        visitor_id: null,
        schedule_id: null,
      },
      schedule_item_id: null,
    };
  },
  computed: {
    eligibleIDs() {
      var results = [];
      this.eligibleTeams.forEach(t => {
        results.push(t.id);
      });
      return results;
    },
    currentSchedule() {
      return this.input && this.input.schedule_id
        ? this.seasonItems.schedules.find(s => s.id === this.input.schedule_id)
        : null;
    },
    eligibleTeams() {
      // To edit a game on /list page
      if (this.currentSchedule && this.currentSchedule.division_id) {
        let result;
        if (this.currentSchedule.divisions.length) {
          const divisionsId = this.currentSchedule.divisions.map(d => d.id);
          result = (this.teams || []).filter(t => divisionsId.includes(t.division_id));
        } else {
          result = (this.teams || []).filter(t => t.division_id === this.currentSchedule.division_id);
        }
        return result.length > 0
          ? result
          : this.seasonItems.teams.filter(t => t.division_id === this.currentSchedule.division_id);
      }

      if (this.schedule && this.schedule.division_id) {
        if (this.schedule.division.across_divisions.length) {
          return this.seasonItems.teams.filter(t => this.schedule.division.across_divisions.includes(t.division_id));
        } else {
          return this.seasonItems.teams.filter(t => t.division_id === this.schedule.division_id);
        }
      }

      return this.seasonItems.teams;
    },
    isGame() {
      // this.po(this.input, "isGame")
      return this.input && this.input.home.id && this.input.home.id.length;
    },
    title() {
      if (this.iscalendar) {
        if (this.isGame) {
          return this.$t("edit-game");
        } else {
          return this.$t("create-game");
        }
      }
      var str = "";
      if (this.input) {
        if (this.isGame) {
          str += this.$t("edit-game");
        } else {
          str += this.$t("edit-timeslot");
        }
      } else {
        str += this.$t("create-game");
      }
      if (this.schedule && this.schedule.name) {
        str += " in " + this.schedule.name;
      }
      return str;
    },
    seasonItems() {
      if (!this.$store.getters.currentSeason) {
        return {};
      }
      var venues = [];
      var teams = [];
      var surfaces = [];
      var division_ids = null;
      if (this.schedule && this.schedule.division_ids) {
        division_ids = [this.schedule.division_id];
      }
      if (this.schedule && this.schedule.division && this.schedule.division.is_across) {
        division_ids = this.schedule.division.across_divisions;
      }

      this.$store.getters.currentSeason.venues.forEach(v => {
        venues.push({
          name: v.name,
          id: v.id,
          surfaces: v.surfaces,
        });
        if (this.timeslot.venue_id === v.id) {
          v.surfaces.forEach(s => {
            surfaces.push(s);
          });
        }
      });

      this.$store.getters.currentSeason.teams.forEach(t => {
        if (!division_ids || !division_ids.length || division_ids.includes(t.division_id)) {
          const team = {
            name: t.name,
            id: t.id,
            division_id: t.division_id,
          };
          teams.push(team);
        }
      });

      return {
        venues: venues,
        teams: teams,
        surfaces: surfaces,
        schedules: this.$store.getters.currentSeason.schedules,
      };
    },
    valid() {
      // this.po(this.timeslot, "Valid slot")
      var x =
        !!this.timeslot.start &&
        !!this.timeslot.finish &&
        !!this.timeslot.venue_id &&
        !!this.timeslot.surface_id &&
        (!this.isGame || (!!this.game.home_id && !!this.game.visitor_id));
      var y = !this.iscalendar || (!!this.game.home_id && !!this.game.visitor_id);
      return x && y;
    },
  },
  methods: {
    startSplit() {
      console.log(this.input.id);
      var x = window.confirm(
        this.$t("split-game-to-make-double-header-this-will-create-2-games-by-splitting-this-timeslot-in-half"),
      );
      if (x) {
        api
          .splitScheduleItem(this.input.id)
          .then(response => {
            this.makeToast("success", this.$t("Toast.success"));
            console.log(response);
            this.$emit("refresh");
          })
          .catch(e => {
            this.makeToast("error", this.$t("error"));
            console.log(e);
          });
      }
    },
    swapTeams() {
      var h = this.game.home_id;
      var v = this.game.visitor_id;
      this.game.home_id = v;
      this.game.visitor_id = h;
    },
    startRemove(shouldDelete) {
      console.log("remove: " + shouldDelete);
      if (shouldDelete) {
        var x = window.confirm(
          this.$t("are-you-sure-you-want-to-delete-this-game-the-pairing-will-be-deleted-this-cannot-be-undone"),
        );
        if (x) {
          api
            .deleteScheduleItems({
              items: [this.input.id],
            })
            .then(response => {
              this.makeToast("success", this.$t("Toast.delete_game"));
              this.$emit("deletegame", this.input.id);
            })
            .catch(e => {
              console.log(e);
              this.makeToast("error", this.$t("could-not-delete-game"));
            });
        }
      } else {
        var x = window.confirm(
          this.$t(
            "are-you-sure-you-want-to-unschedule-this-game-the-pairing-will-be-preserved-and-it-will-be-sent-to-the-unscheduled-list",
          ),
        );
        if (x) {
          api
            .unscheduleItems({
              items: [this.input.id],
            })
            .then(response => {
              console.log(response);
              this.makeToast("success", this.$t("Toast.unscheduled-game"));
              this.$emit("unschedulegame", this.input.id);
            })
            .catch(e => {
              console.log(e);
              this.makeToast("error", this.$t("Toast.could-not-complete-action"), this.input.id);
            });
        }
      }
    },
    checkEnd() {
      if (!this.input) {
        return;
      }
      if (!this.timeslot.finish || !this.timeslot.start) {
        return;
      }
      if (this.timeslot.finish < this.timeslot.start) {
        console.log(this.timeslot.finish, this.timeslot.start);
        alert(this.$t("finish-must-be-after-end"));
        return;
      }
    },
    setEnd() {
      if (this.iscalendar) {
        return;
      }
      console.log("Set end");
      if (!this.timeslot.start) {
        return;
      }
      if (!this.timeslot.finish) {
        this.timeslot.finish = this.$moment(this.timeslot.start)
          .add(2, "hours")
          .format();
      }
    },
    assign(item) {
      console.log("Assign", item);
      this.updateItem = item;
      this.game = item.game;
      this.game.home_id = item.game.home.id;
      this.game.visitor_id = item.game.visitor.id;
      this.save();
    },
    save() {
      if (this.timeslot.finish < this.timeslot.start) {
        alert(this.$t("finish-must-be-after-start"));
        return;
      }
      var item = {
        id: this.updateItem ? this.updateItem.id : this.input ? this.input.id : null,
        timeslot: this.updateItem ? this.input : this.timeslot,
        game: this.game,
      };
      this.po(item, "ITEM");
      if (this.input) {
        this.updateGame(item);
      } else {
        console.log("Going to create!", this.schedule);
        item.game.schedule_id = this.schedule.id;
        this.createGame(item);
      }
    },
    createGame(item) {
      console.log("CreateGame");
      api
        .createScheduleItem(this.$store.getters.currentSeason.id, item)
        .then(response => {
          console.log(response);
          this.makeToast("success", this.$t("created-game"));
          this.$emit("gamecreated", response.data);
        })
        .catch(e => {
          this.updateItem = null;
          console.log(e);
          this.makeToast("error", e.response.data["errors"]);
        });
    },
    updateGame(item) {
      console.log("⭐️ UpdateGame", item);
      if (this.iscalendar) {
        console.log("CALENDAR");
        api
          .updateCalendarItem(this.$store.getters.currentSeason.id, item)
          .then(response => {
            this.makeToast("success", this.$t("Toast.success"));
            console.log(response);
            this.$emit("updated", [item.id]);
            // if (item.game.home_id) {
            //   this.$emit("updated", response.data);
            // } else {
            //   console.log("Is Timeslot")
            //   this.$emit("updated", item)
            // }
            this.updateItem = null;
            this.$emit("hide");
          })
          .catch(e => {
            this.updateItem = null;
            console.log(e);
          });
        return;
      }
      api
        .updateScheduleItem(this.$store.getters.currentSeason.id, item)
        .then(response => {
          if (response.data.errors) {
            this.makeToast("error", response.data.errors);
            return;
          }
          this.makeToast("success", this.$t("Toast.success"));
          console.log(response);
          this.$emit("updated", [item.id]);
          // if (item.game.home_id) {
          //   this.$emit("updated", response.data);
          // } else {
          //   console.log("Is Timeslot")
          //   this.$emit("updated", item)
          // }
          this.updateItem = null;
          this.$emit("hide");
        })
        .catch(e => {
          this.updateItem = null;
          console.log(e);
        });
    },
    emitHide() {
      this.updateItem = null;
      this.$emit("hide");
    },
    refresh() {
      this.updateItem = null;
      this.$emit("refresh");
    },
  },
  watch: {
    timeslot: function(val) {
      console.log("Valid is  " + this.valid);
    },
    active: function(val) {
      if (val && !this.input) {
        // var x = new Date();
        // if (this.start) {
        //   x = new Date(this.start);
        // }
        // x.setHours(x.getHours() + 2);
        // this.timeslot.start = x.toISOString();
        // x.setHours(x.getHours() + 4);
        // this.timeslot.finish = x.toISOString();
        this.game = {
          home_id: null,
          visitor_id: null,
          schedule_id: null,
        };
      }
      console.log("Active...");

      if (this.input) {
        // this.po(this.input, "input...")
        this.schedule_item_id = this.input.id;
        // console.log("\n\n\n Set Inputs...", this.input);
        // console.log(" -- start: " + this.input.timeslot.start);
        // console.log(" -- finish: " + this.input.timeslot.finish);
        // console.log(" -- surface_id: " + this.input.surface.id);
        // console.log(" -- venue_id: " + this.input.timeslot.venue.id);
        // console.log(" -- home_id: " + this.input.home.id);
        // console.log(" -- visitor_id: " + this.input.visitor.id);
        this.game.home_id = this.input.home.id;
        this.game.visitor_id = this.input.visitor.id;
        var x = new Date(this.input.timeslot.start).toISOString();
        console.log("Start " + this.input.timeslot.start + " --> " + x);
        if (this.isGame) {
          // console.log("TS: " + this.timeslot.start)
          // console.log("X: " + x)
          // console.log("TS OR X: " + this.timeslot.start || x)
          this.timeslot.start = x || this.timeslot.start;
          console.log("is_game: " + this.timeslot.start);
          if (this.input.timeslot.finish) {
            console.log("has finish");
            this.timeslot.finish = new Date(this.input.timeslot.finish).toISOString();
          } else {
            console.log("NO finish");
            var x = new Date(this.input.timeslot.start);
            x.setHours(x.getHours() + 2);
            this.timeslot.finish = x.toISOString();
          }
        } else if (!this.iscalendar) {
          this.timeslot.start = new Date(this.input.timeslot.start).toISOString();
          this.timeslot.finish = new Date(this.input.timeslot.finish).toISOString();
        }
        this.po(this.input, "Input...");
        this.timeslot.surface_id = this.input.surface.id;
        this.timeslot.venue_id = this.input.timeslot.venue.id;
        // this.timeslot.start = new Date(this.input.timeslot.start).toISOString()
        // this.timeslot.end = new Date(this.input.timeslot.end).toISOString()
        if (this.schedule) {
          this.game.schedule_id = this.schedule.id;
        } else {
          this.game.schedule_id = this.input.schedule_id;
        }
      }
      if (this.iscalendar && this.input) {
        console.log("IsCalendar, use old timeslot", this.input.timeslot);
        this.game.schedule_id = this.input.game && this.input.game.schedule_id;
        var s = new Date(this.input.timeslot.start).toISOString();
        var e = new Date(this.input.timeslot.end).toISOString();
        console.log(s);
        console.log(e);
        this.timeslot.start = s;
        this.timeslot.finish = e;
      }
      if (!this.game.schedule_id && this.seasonItems.schedules.length > 0) {
        console.log("No schedule ID....", this.input);
        // console.log("Set first schedule");
        // this.game.schedule_id = this.schedule
        //   ? this.schedule.id
        //   : this.seasonItems.schedules[0].id;
      }
    },
    "timeslot.start"(val) {
      // if (
      //   val &&
      //   (!this.timeslot.finish || this.timeslot.finish < this.timeslot.start)
      // ) {
      //   var today = new Date(this.timeslot.start);
      //   today.setHours(today.getHours() + 2);
      //   this.timeslot.finish = today.toISOString();
      // }
    },
    "timeslot.venue_id"(val, oldVal) {
      if (val && oldVal) {
        this.timeslot.surface_id = null;
        console.log("Need to set");
        this.seasonItems.venues.forEach(v => {
          if (v.id == val) {
            console.log("Found");
            this.timeslot.surface_id = v.surfaces[0].id;
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
